import {Aside} from './components/Aside/Aside';
import { Statistic } from './components/Statistic/Statistic';

function App() {
  return (
    <div className="container main-container">
        <Aside/>
        <Statistic/>
    </div>
  );
}

export default App;
